module.exports = __webpack_public_path__ + "img/hotspot.944df432.png";